(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "styledComponents", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["UiToolkit"] = factory(require("react"), require("styled-components"), require("react-dom"));
	else
		root["UiToolkit"] = factory(root["React"], root["styledComponents"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__18__) {
return 